module.exports = __webpack_public_path__ + "img/PM_4.b756c867.svg";